import {createApi} from "@reduxjs/toolkit/query/react";
import {baseQueryWithReAuth} from "@/store/api/baseQueryWithReAuth";

export interface ChatImage {
    id: number;
    name: string;
    support_chat: number;
    file_base64: string;
}
export interface SupportChat {
    id: number;
    sender: string;
    text: string;
    send_date_time: string;
    support: number;
    image_list: ChatImage[];
}
export interface Support {
    id: number;
    title: string;
    create_date_time: string;
    close_date_time: string;
    status: string;
    count_message: string;
    count_message_type: string;
    company: number;
    service: number;
    chat_list: SupportChat[];
    service_name: string;
    company_name: string;
}

export const supportApi = createApi({
    reducerPath: "supportApi",
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        getSupports: builder.query<Support[], number>({
            query: (companyId) => `/client-support/${companyId}/`
        }),
    })
})

export const {useGetSupportsQuery} = supportApi;